<template>
  <div class="card-details-fields">
    <select-input
      id="category"
      v-model="card.category"
      label="*Category"
      searchable
      :options="categoryOptions"
      :disabled="disabled"
    />

    <text-input
      id="year"
      v-model.trim="card.year"
      label="*Year"
      placeholder="2018"
      maxlength="10"
      required
      :disabled="disabled"
    />

    <text-input
      id="set"
      v-model.trim="card.set"
      label="*Set"
      placeholder="Prizm"
      maxlength="64"
      required
      :disabled="disabled"
    />

    <text-input
      id="player"
      v-model.trim="card.player"
      label="*Player"
      placeholder="Luka Doncic"
      maxlength="64"
      required
      :options="playerOptions"
      :loading="loadingPlayers"
      :disabled="disabled"
      @input="loadPlayers"
    />

    <text-input
      id="number"
      v-model.trim="card.number"
      label="Number"
      placeholder="280"
      maxlength="12"
      :disabled="disabled"
    />

    <text-input
      id="variation"
      v-model.trim="card.variation"
      label="Variation"
      placeholder="Silver Prizm"
      maxlength="64"
      :disabled="disabled"
    />

    <select-input
      v-if="!card.cert"
      id="condition"
      v-model="card.condition"
      label="*Condition"
      searchable
      :options="conditionOptions"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';

import { CATEGORY_OPTIONS, CONDITION_OPTIONS } from '@cardladder/shared/constants';

import { searchService } from '@/services';

export default {
  props: {
    value: Object,
    disabled: Boolean,
  },

  data() {
    return {
      card: this.value,
      categoryOptions: CATEGORY_OPTIONS,
      conditionOptions: CONDITION_OPTIONS,
      playerList: [],
      loadingPlayers: false,
    };
  },

  mounted() {
    this.loadPlayers = debounce(this.loadPlayers, 1000);
  },

  watch: {
    card: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },

    value(value) {
      this.card = value;
    },
  },

  computed: {
    playerOptions() {
      return this.playerList
        .map(({ id, name }) => ({ value: id, label: name }));
    },
  },

  methods: {
    async loadPlayers() {
      this.loadingPlayers = true;

      try {
        const data = await searchService.search({
          index: 'playerlist',
          query: this.card.player || '',
        });

        this.playerList = data.hits;
      } catch (e) {
        // swallow
      }

      this.loadingPlayers = false;
    },
  },
};
</script>
